import { checkComponentPresence, getSelectedElement, propComparator, propComparatorDate } from "../utils/ui_utils"
import { getCowLight } from "./cow"

export const award_filter_sublist = [
    { id: 'all', label: 'Tutti', color: 'primary', label_short: 'bk', color: 'all' },
    { id: 'black', label: 'black', color: 'black', label_short: 'bk', color: 'black' },
    { id: 'red', label: 'red', color: 'error', label_short: 'red', color: 'red' }
]
export const award_filter_subdict = {
    all: { id: 'all', label: 'Tutti', color: 'primary', label_short: 'T' },
    black: { id: 'black', label: 'black', color: 'black', label_short: 'bk' },
    red: { id: 'red', label: 'red', color: 'error', label_short: 'red' }
}


export const cleanMatch = (m) => {
    let _m = {
        id: m.id,
        is_public: m.is_public,
        match_name: m.match_name,
        match_shortname: m.match_shortname,
        export_position_limit: m.export_position_limit,
        match_description: m.match_description,
        match_type: m.match_type,
        planned_start: m.planned_start,
        cow_list: []
    }
    if (m.link_to_category) {
        _m.link_to_category = m.link_to_category
        _m.linked_category = m.linked_category
    }
    if (m.use_dynamic_list) {
        _m.source_list_data = m.source_list_data
        _m.use_dynamic_list = m.use_dynamic_list
    }
    if (m.award_label_list) {
        _m.award_label_list = m.award_label_list
    }
    if (m.award_list) {
        _m.award_list = m.award_list
    }
    console.log(_m)
    return _m

}



export const getAwardLabel = (position_id, label_list, short) => {
    let label = `${position_id + 1}ª classificata`
    if (label_list) {
        const p_label = label_list.filter(e => e.position === position_id + 1)
        if (short) {
            if (p_label.length > 0 && p_label[0].award_shortname && p_label[0].award_shortname.length > 0) {
                label = p_label[0].award_shortname
            }

        } else {
            if (p_label.length > 0 && p_label[0].award_name && p_label[0].award_name.length > 0) {
                label = p_label[0].award_name
            }
        }
    }
    return label

}

const getPosition = (k, export_position_limit, overflow_as_limit, position) => {
    const _position_limit = export_position_limit ? parseInt(export_position_limit) : 0
    if (_position_limit === 0 || k < _position_limit) {
        return position
    } else {
        if (overflow_as_limit) {
            return export_position_limit
        }
    }
    return -1
}


export const getAwardDescription = (match, position, sl, k) => {
    if (match.link_to_category) {
        if (match.linked_category && match.linked_category.category_name) {
            console.log("LIMIT", match.export_position_limit, position, k)
            const _position = getPosition(k, match.export_position_limit, match.overflow_as_limit, position)
            const nmb = match.linked_category.category_name.split('a')[0]
            return `C.${nmb}:${_position + 1},`
        }
    } else if (sl) {
        return `${sl}${match.match_shortname}`
    }
    return ''
}




export const initCowlist = (el, match_list, source_cow_list) => {
    let confirm_mode = ''
    let not_completed = 0
    let linked_cow_list = []
    let dynamic_cow_list = []
    let selected_source_cow = []
    let _cow_list = []
    let _cow_id_list = []
    if (el.use_dynamic_list) {
        confirm_mode = 'dynamic'
        if (el.source_list_data) {
            const s_key = Object.keys(el.source_list_data)
            const m_list = match_list.filter(e => e.id && s_key.includes(e.id))
            //console.log("NOT COMPLETED", m_list.filter(e => e.status !== 'end').length)
            not_completed = m_list.filter(e => e.status !== 'end').length
            //for (const m of m_list.filter(e => e.status === 'end')) {
            for (const m of m_list) {
                const a = el.source_list_data[m.id]
                const a_data = Object.entries(a)
                const aw_list = a_data.map(ak => (
                    { ...ak[1], ...getSelectedElement(ak[0], m.award_list, 'id') }
                ))
                for (const award of aw_list.sort(propComparator('order'))) {
                    const result = getSelectedElement(award.id, m.result_list, 'id')
                    //                        const award = getSelectedElement(ak[0], m.award_list, 'id')
                    let c_list = []
                    c_list = result.cow_list?.filter(c => !c.squalified)
                    console.log("INIT COWLIST MATCH", award.filter_applied, c_list)
                    if (c_list) {
                        if (award.filter_applied === 'red') {
                            c_list = c_list.filter(c => c.cow?.cow_type === 'red')
                        } else if (award.filter_applied === 'black') {
                            c_list = c_list.filter(c => c.cow?.cow_type === 'black')
                        } else if (award.filter_applied !== undefined) {
                            c_list = c_list.filter(c => {
                                return c.cow && c.cow[award.filter_applied] === true
                            })
                        }

                    }
                    if (c_list?.length > 0) {
                        if (award.has_position) {
                            for (const p of award.position_list) {
                                const c = c_list[p - 1]
                                if (c && c.cow) {
                                    const award_data = {
                                        match_name: m.match_name, match_description: m.match_description, id: m.id, position_id: c.position_id + 1,
                                        award_label: getAwardLabel(c.position_id, m.award_label_list)
                                    }
                                    const c_pos = _cow_id_list.indexOf(c.cow.id)
                                    if (c_pos >= 0) {
                                        let ccc = { ..._cow_list[c_pos] }
                                        ccc.award_source_list.push(award_data)
                                        _cow_list.splice(c_pos, 1, ccc)
                                    } else {
                                        const new_cow = {
                                            ...cleanMatchCow(getSelectedElement(c.cow.id, m.cow_list, 'id')),
                                            award_source_list: [
                                                award_data
                                            ]
                                        }
                                        _cow_list.push(new_cow)
                                        _cow_id_list.push(c.cow.id)
                                    }
                                }

                            }
                            /*                             c_list = _.map(award.position_list.map(p => (p - 1)), function (item) {
                                                            return c_list[item]
                                                        }).filter(c => c !== undefined).map(c => {
                                                            console.log("CCC", c)
                                                            return { ...cleanCow(getSelectedElement(c.cow.id, m.cow_list, 'id')), award_source_data: { match_name: m.match_name, match_description: m.match_description, id: m.id, position_id: c.position_id + 1 } }
                                                        }) */
                        } else {
                            for (const c of c_list) {
                                if (c !== undefined) {
                                    const award_data = {
                                        match_name: m.match_name, match_description: m.match_description, id: m.id, position_id: c.position_id + 1,
                                        award_label: award.award_name
                                    }
                                    console.log("COW LISTR", c)
                                    if (c.cow) {
                                        const c_pos = _cow_id_list.indexOf(c.cow.id)
                                        console.log(award_data)
                                        if (c_pos >= 0) {
                                            let ccc = { ..._cow_list[c_pos] }
                                            ccc.award_source_list.push(award_data)
                                            _cow_list.splice(c_pos, 1, ccc)
                                        } else {
                                            const new_cow = {
                                                ...cleanMatchCow(getSelectedElement(c.cow.id, m.cow_list, 'id')),
                                                award_source_list: [
                                                    award_data
                                                ]
                                            }
                                            _cow_list.push(new_cow)
                                            _cow_id_list.push(c.cow.id)
                                        }
                                    }
                                }
                                /*                         c_list = c_list.filter(c => c !== undefined).map(c => {
                                                            const update_c = cleanCow(getSelectedElement(c.cow.id, m.cow_list, 'id'))
                                                            return { ...update_c, award_source_data: { match_name: m.match_name, match_description: m.match_description, id: m.id, position_id: award.award_name } }
                                                        }) */
                            }
                        }
                        //_cow_list = [..._cow_list, ...c_list]
                    }
                }



            }
        }
        dynamic_cow_list = _cow_list
        linked_cow_list = []
    } else {
        not_completed = 0
        console.log("e", el.linked_category, source_cow_list)
        confirm_mode = 'linked'
        dynamic_cow_list = []
        if (el.link_to_category && el.linked_category && source_cow_list) {
            linked_cow_list = source_cow_list.sort(propComparatorDate('birthdate', true, 'catalog_id'))
            selected_source_cow = source_cow_list?.filter(c => c.is_present === true).map(c => c.id)
        } else {
            linked_cow_list = []
            selected_source_cow = []

        }
    }
    return { confirm_mode, linked_cow_list, dynamic_cow_list, selected_source_cow, not_completed, cow_list: _cow_list }

}


const cleanMatchCow = (cow) => {
    let c = { ...cow }
    delete c.is_in_ring
    return c
}


export const getFilteredList = (match_id, result_list, cow_list, result_id) => {
    const filtered_list = []
    console.log("----", result_list)
    if (result_list) {
        for (const a of result_list) {
            console.log("FILTERED RESULT", a)
            if (a.filter_data_list && a.filter_data_list.length > 0) {
                for (const f of a.filter_data_list) {
                    const c_list = a.cow_list.map(c => c.cow?.id).filter(c => c !== undefined)
                    const e_c_list = a.has_position ? cow_list.filter(c => !c_list.includes(c.id)) : []
                    console.log("FFF", f)
                    if (f === 'all') {
                        filtered_list.push({ cow_list: a.cow_list.filter(c => !c.cow?.squalified), has_position: a.has_position, id: a.id, name: a.award_name, subname: 'complessiva', no_match_cow_list: e_c_list, data_filter: f })
                    } else if (f === 'red') {
                        filtered_list.push({ cow_list: a.cow_list.filter(c => !c.cow?.squalified).filter(c => c.cow.cow_type === 'red'), has_position: a.has_position, id: a.id, name: a.award_name, subname: 'red', no_match_cow_list: e_c_list.filter(c => c.cow_type === 'red'), data_filter: f })
                    } else if (f === 'black') {
                        filtered_list.push({ cow_list: a.cow_list.filter(c => !c.cow?.squalified).filter(c => c.cow.cow_type === 'black'), has_position: a.has_position, id: a.id, name: a.award_name, subname: 'black', no_match_cow_list: e_c_list.filter(c => c.cow_type === 'black'), data_filter: f })
                    } else {
                        filtered_list.push({ cow_list: a.cow_list.filter(c => !c.cow?.squalified).filter(c => c.cow[f] === true), has_position: a.has_position, id: a.id, name: a.award_name, subname: f, no_match_cow_list: e_c_list.filter(c => c.cow[f] === true), data_filter: f })
                    }
                }
            } else {
                if (a.from_other_data) {
                    const c_list = cow_list.filter(c => c.award_dict[match_id + "_" + a.id]?.position >= 0).map(c => ({ ...c, cow: getSelectedElement(c.id, cow_list, 'id') }))
                    filtered_list.push({ cow_list: c_list, has_position: a.has_position, id: a.id, name: a.award_name, no_match_cow_list: [], award_value: { name: a.award_name, value: a.award_value } })
                } else {
                    const c_list = a.cow_list.map(c => c.cow?.id).filter(c => c !== undefined)
                    console.log("FILTERED RESULT COW LIST ", c_list)
                    const e_c_list = a.has_position ? cow_list.filter(c => !c_list.includes(c.id)) : []
                    filtered_list.push({ cow_list: a.cow_list.filter(c => c.cow && c.cow.id).map(c => ({ ...c, cow: getSelectedElement(c.cow.id, cow_list, 'id') })), has_position: a.has_position, id: a.id, name: a.award_name, no_match_cow_list: e_c_list })
                }
            }

        }
    }
    console.log("FILTERED LIST BOH", filtered_list)
    if (result_id) {
        //------FIXME
        
        if (filtered_list.filter(r => r.id === result_id && r.data_filter === 'all').length>0){
            return filtered_list.filter(r => r.id === result_id && r.data_filter === 'all')[0]
        }else{
        return filtered_list.filter(r => r.id === result_id)[0]

        }
    } else {
        return filtered_list

    }
}




export const getPointData = (sel_match, match_list, cow_list, setNotCompleted) => {
    let filtered_list = []
        let _cow_list = []
    if (sel_match.source_list_data) {

        const s_key = Object.keys(sel_match.source_list_data)
        const m_list = match_list?.filter(e => s_key.includes(e.id))
        if (setNotCompleted) {
            setNotCompleted(m_list?.filter(e => e.status !== 'end').length)
        }
        for (const m of m_list) {
            const a = sel_match.source_list_data[m.id]
            const ak = Object.entries(a)[0]
            //                console.log("AK", m.result_list)
            if (m.result_list) {
                for (const r of m.result_list) {
                    if (r) {
                        const award = getSelectedElement(r.id, m.award_list, 'id')
                        if (award.point_list && award.point_list.length > 0) {
                            //                               console.log("RESULT-point", award.point_list)
                            let c_list = r.cow_list.filter((c, k) => {
                                if (award.limit_count === 0 || !award.limit_in_single_match || k < award.limit_count) {
                                    return true
                                }
                                return false
                            }).map((c, k) => {
                                //                                    console.log("POINT", award.point_list[k], c)
                                if (c.cow) {
                                    let real_cow = {}
                                    if (cow_list) {
                                        real_cow = getSelectedElement(c.cow.id, cow_list, 'id')
                                    } else {
                                        real_cow = c.cow
                                    }
                                    if (c.cow.property?.id !== real_cow.property?.id) {
                                        console.log("\t\t\tDIFFERENT property", c.cow.property?.id, real_cow.property?.id)
                                    }
                                    return {
                                        cow: real_cow, // getSelectedElement(c.cow.id, cow_list, 'id'),
                                        match_point: award.point_list[k] ? award.point_list[k] : 0,
                                        match_data: {
                                            name: m.match_name,
                                            award: award.award_name,
                                            award_description: r.has_position ? `${award.award_name}: ${k + 1}` : award.award_name,
                                            has_position: r.has_position,
                                            position: k
                                        }
                                    }

                                } else {
                                    return undefined
                                }
                            }).filter(c => c !== undefined)
                            _cow_list = [..._cow_list, ...c_list]
                        }
                    }
                }
            }
        }
    }
    for (const a of sel_match.award_list.filter(e => e.from_other_data)) {
        console.log("AWARD", a)
        let _data_dict = {}
        const limit_count = a.limit_count ? parseInt(a.limit_count) : 0
        if (a.groupby === 'cowman') {
            //GROUP BY COWMAN
            for (const cow of _cow_list) {
                if (cow.cow.cowman && cow.cow.cowman.id) {
                    if (!_data_dict[cow.cow.cowman.id]) {
                        _data_dict[cow.cow.cowman.id] = {
                            ...cow.cow.cowman,
                            cow_list: [],
                            cow_id: {},
                            total_point: 0
                        }
                    }
                    let cl = [..._data_dict[cow.cow.cowman.id].cow_list]
                    if (_data_dict[cow.cow.cowman.id].cow_id[cow.cow.id]) {
                        const c_index = checkComponentPresence({ ...cow.cow }, cl, 'id')
                        if (c_index >= 0) {
                            let p = _data_dict[cow.cow.cowman.id].cow_list[c_index].match_point
                            console.log("POINT", p)
                            //cl.splice(c_index,1, {..._data_dict[cow.cow.cowman.id].cow_list[c_index], match_point: p.cow?.match_point} )

                            cl.splice(c_index, 1, {
                                ..._data_dict[cow.cow.cowman.id].cow_list[c_index],
                                match_point: cow?.match_point + _data_dict[cow.cow.cowman.id].cow_list[c_index].match_point,
                                match_data_list: [..._data_dict[cow.cow.cowman.id].cow_list[c_index].match_data_list, { match_data: cow.match_data, match_point: cow.match_point }]
                            })

                        }
                    } else {
                        cl.push(
                            {
                                ...cow.cow, match_point: cow.match_point, match_data_list: [
                                    { match_data: cow.match_data, match_point: cow.match_point }
                                ]
                            }
                        )
                    }
                    cl = cl.sort(propComparator('match_point'))
                    _data_dict[cow.cow.cowman.id].cow_list = cl.reverse()
                    _data_dict[cow.cow.cowman.id].cow_id[cow.cow.id] = { ...getCowLight(cow.cow) }
                    _data_dict[cow.cow.cowman.id].total_point += cow.match_point
                }
            }

        } else if (a.groupby === 'property') {
            //GROUP BY PROPERTY
            for (const cow of _cow_list) {
                if (cow.cow.property && cow.cow.property.id) {
                    if (!_data_dict[cow.cow.property.id]) {
                        _data_dict[cow.cow.property.id] = {
                            ...cow.cow.property,
                            cow_list: [],
                            cow_id: {},
                            total_point: 0
                        }
                    }
                    let cl = [..._data_dict[cow.cow.property.id].cow_list]
                    if (_data_dict[cow.cow.property.id].cow_id[cow.cow.id]) {
                        const c_index = checkComponentPresence({ ...cow.cow }, cl, 'id')
                        if (c_index >= 0) {
                            let p = _data_dict[cow.cow.property.id].cow_list[c_index].match_point
                            console.log("POINT", p)
                            //cl.splice(c_index,1, {..._data_dict[cow.cow.property.id].cow_list[c_index], match_point: p.cow?.match_point} )
                            cl.splice(c_index, 1, {
                                ..._data_dict[cow.cow.property.id].cow_list[c_index],
                                match_point: cow?.match_point + _data_dict[cow.cow.property.id].cow_list[c_index].match_point,
                                match_data_list: [..._data_dict[cow.cow.property.id].cow_list[c_index].match_data_list, { match_data: cow.match_data, match_point: cow.match_point }]
                            })
                        }
                    } else {
                        cl.push(
                            {
                                ...cow.cow, match_point: cow.match_point, match_data_list: [
                                    { match_data: cow.match_data, match_point: cow.match_point }
                                ]
                            }
                        )
                    }
                    cl = cl.sort(propComparator('match_point'))
                    _data_dict[cow.cow.property.id].cow_list = cl.reverse()
                    _data_dict[cow.cow.property.id].cow_id[cow.cow.id] = { ...getCowLight(cow.cow) }
                    _data_dict[cow.cow.property.id].total_point += cow.match_point
                }
            }
        } else {
            //GROUP BY cross 
            for (const cow of _cow_list) {
                if (true) {
                    if (cow.cow[a.groupby]) {
                        if (!_data_dict[cow.cow[a.groupby]]) {
                            _data_dict[cow.cow[a.groupby]] = {
                                name: cow.cow[a.groupby],
                                cow_list: [],
                                cow_id: {},
                                total_point: 0
                            }
                        }
                        let cl = [..._data_dict[cow.cow[a.groupby]].cow_list]
                        if (_data_dict[cow.cow[a.groupby]].cow_id[cow.cow.id]) {
                            const c_index = checkComponentPresence({ ...cow.cow }, cl, 'id')
                            if (c_index >= 0) {
                                let p = _data_dict[cow.cow[a.groupby]].cow_list[c_index].match_point
                                console.log("POINT", p)
                                //cl.splice(c_index,1, {..._data_dict[cow.cow[a.groupby]].cow_list[c_index], match_point: p.cow?.match_point} )
                                cl.splice(c_index, 1, {
                                    ..._data_dict[cow.cow[a.groupby]].cow_list[c_index],
                                    match_point: cow?.match_point + _data_dict[cow.cow[a.groupby]].cow_list[c_index].match_point,
                                    match_data_list: [..._data_dict[cow.cow[a.groupby]].cow_list[c_index].match_data_list, { match_data: cow.match_data, match_point: cow.match_point }]
                                })
                            }
                        } else {
                            cl.push(
                                {
                                    ...cow.cow, match_point: cow.match_point, match_data_list: [
                                        { match_data: cow.match_data, match_point: cow.match_point }
                                    ]
                                }
                            )
                        }
                        cl = cl.sort(propComparator('match_point'))
                        _data_dict[cow.cow[a.groupby]].cow_list = cl.reverse()
                        _data_dict[cow.cow[a.groupby]].cow_id[cow.cow.id] = { ...getCowLight(cow.cow) }
                        _data_dict[cow.cow[a.groupby]].total_point += cow.match_point
                    }
                }
            }

        }
        let p_list = []

        for (const g_id in _data_dict) {
            let _g = _data_dict[g_id]
            if (limit_count > 0 && !a.limit_in_single_match && _g.cow_list.length > limit_count) {
                console.log("LIMIT COUNT")
                _g.real_total_point = _g.total_point
                _g.cow_list = _g.cow_list.map((c, k) => {
                    if (k < limit_count) {
                        return c
                    } else {
                        return { ...c, is_invalid: true }
                    }
                }
                )
                _g.total_point = _g.cow_list.filter(c => !c.is_invalid).map(c => c.match_point).reduce((partialSum, a) => partialSum + a, 0)
            }
            p_list.push(_g)
            console.log("GROUP", g_id, _g)
        }
        p_list = p_list.sort(propComparator("total_point"))
        p_list.reverse()
        filtered_list.push({ auto_sum: true, id: a.id, name: a.award_name, data_list: p_list })
    }

    return filtered_list


}